export default __webpack_public_path__ + "static/drconecta-patient-hero-76d66c46ae57f557cef52918e15a14e3.png";